'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPageInKeyboardMode = undefined;

var _domReady = require('./domReady');

// https://git.hubteam.com/HubSpot/UIComponents/issues/2642

var HIDE_FOCUS_STYLES_CLASS = 'hubspot-disable-focus-styles';
var SHOW_FOCUS_STYLES_CLASS = 'hubspot-enable-focus-styles';

var keyboardMode = false;

var showFocusOutline = function showFocusOutline() {
  keyboardMode = true;
  document.body.classList.add(SHOW_FOCUS_STYLES_CLASS);
  document.body.classList.remove(HIDE_FOCUS_STYLES_CLASS);
};

var hideFocusOutline = function hideFocusOutline() {
  keyboardMode = false;
  document.body.classList.add(HIDE_FOCUS_STYLES_CLASS);
  document.body.classList.remove(SHOW_FOCUS_STYLES_CLASS);
};

(0, _domReady.domReady)(function () {
  if (!document.body) return;

  // Show the focus outline when keyboard activity occurs
  document.body.addEventListener('keydown', showFocusOutline);

  // Hide the focus outline when mouse activity occurs
  document.body.addEventListener('mousemove', hideFocusOutline);
  document.body.addEventListener('mousedown', hideFocusOutline);
  document.body.addEventListener('mouseup', hideFocusOutline);
});

var isPageInKeyboardMode = exports.isPageInKeyboardMode = function isPageInKeyboardMode() {
  return keyboardMode;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/listeners/focusStylesListener.js
// module id = 153
// module chunks = 2 3